import {Model} from 'backbone';

import GapSequenceWrapper from 'analyses/alignment/GapSequenceWrapper';
import Trim from 'analyses/alignment/Trim';
import {assert} from 'Asserts';
import {TrimSideOption} from 'constants/AlignmentConstants';

/**
 * Set the start/end/both trim of a sequence to the start/end/both of the selection on that sequence
 */
export function setTrimFromSelection(sequence: GapSequenceWrapper, trim: Trim, side: TrimSideOption): void {
  const selection = sequence.get('selection');
  const start = selection.start();
  const end = selection.end();

  switch (side) {
    case TrimSideOption.START:
      trim.setStart(start);
      break;
    case TrimSideOption.END:
      trim.setEnd(end != null ? end : start);
      break;
    case TrimSideOption.BOTH:
      assert(end != null, 'Cannot set trim from selection if selection does not have an end index');
      trim.setBoth(start, end);
      break;
    default:
      assert(false, 'Unexpected trim side');
  }
  trim.renderLineRanges();
}

/**
 * Given a sequence, set the start/end/both trims of all sequences in the alignment to the start/end/both
 * of the selection on that sequence
 */
export function setAllTrimsFromSelection(
  selectedSequence: GapSequenceWrapper,
  alignmentTabState: Model,
  side: TrimSideOption
): void {
  alignmentTabState
    .get('mapstates')
    .map((ms: Model) => ms.get('sequence').get('trim'))
    .forEach((trim: Trim) => {
      if (trim) {
        setTrimFromSelection(selectedSequence, trim, side);
      }
    });
}
